import { MagicTableCellLink } from '@sequencehq/tables'

export const InvoiceLinkCell = ({
  invoice
}: { invoice: { id: string; name: string } | null | undefined }) => {
  if (!invoice) {
    return null
  }

  return (
    <MagicTableCellLink to={`/invoices/${invoice.id}`} label={invoice.name} />
  )
}
